import React, { useRef, useState, useEffect } from "react";
import "../styles/SortSelector.css";

const SortSelector = ({ onSortChange, currentSort = "default" }) => {
  const selectRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  const handleSortChange = (e) => {
    // Apply the sort change
    onSortChange(e.target.value);

    // Blur after selection is made
    if (selectRef.current) {
      setTimeout(() => {
        selectRef.current.blur();
      }, 50);
    }
  };

  // Handle the click event on the select element
  const handleClick = () => {
    // Toggle the dropdown state
    setIsOpen(!isOpen);

    // If we're closing the dropdown, blur the element
    if (isOpen && selectRef.current) {
      setTimeout(() => {
        selectRef.current.blur();
      }, 50);
    }
  };

  // Handle blur event to update our tracking state
  const handleBlur = () => {
    setIsOpen(false);
  };

  // Listen for mousedown events outside the select to handle edge cases
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (selectRef.current && !selectRef.current.contains(e.target)) {
        setIsOpen(false);
        selectRef.current.blur();
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  return (
    <div className="sort-selector-container">
      <div className="select-wrapper">
        <select
          ref={selectRef}
          className="sort-selector"
          onChange={handleSortChange}
          onClick={handleClick}
          onBlur={handleBlur}
          value={currentSort}
        >
          <option value="default">Asortare: implicit</option>
          <option value="price-asc">Preț: crescător</option>
          <option value="price-desc">Preț: descrescător</option>
        </select>
        <div className="select-arrow"></div>
      </div>
    </div>
  );
};

export default SortSelector;
